import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITransactionsHistoryState } from '@shared/models';
import * as Response from '@shared/models/dashboard/dashboard.response.type';
import { fetchTransactionsHistory } from '../queries';

const state: ITransactionsHistoryState = {
    fetching: false,
    data: {
        coins: [],
        history: null,
    },
};

const transactionSlice = createSlice({
    name: 'dashboard-transaction',
    initialState: state,
    reducers: {
        setTransactionsHistory: (state, { payload }: PayloadAction<Response.ITransactionsHistoryResponseType>) => {
            if (payload.page && payload.page === 1) {
                state.data = {
                    coins: payload.coins,
                    history: payload.history,
                };
            } else {
                state.data = {
                    coins: [...state.data.coins, ...payload.coins],
                    history: state.data.history,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTransactionsHistory.pending, (state) => {
            state.fetching = true;
        });
        builder.addCase(fetchTransactionsHistory.rejected, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchTransactionsHistory.fulfilled, (state) => {
            state.fetching = false;
        });
    },
});

export const { setTransactionsHistory } = transactionSlice.actions;
export default transactionSlice.reducer;
